/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IndexSearchFilter } from './indexSearchFilter';


export interface IndexSearchRequest { 
    /**
     * The search term upon which to search
     */
    searchTerm?: string;
    /**
     * A list of index search filters. Multiple filters are supported which are AND-ed
     */
    indexSearchFilters?: Array<IndexSearchFilter>;
    /**
     * A list of Facet Fields to be included with the response. Only Tag and ResultType facet information is supported                
     */
    facetFields?: Array<string>;
    /**
     * An optional boolean flag that specifies if highlighting should be enabled on the matched terms or not                
     */
    enableHitHighlighting?: boolean;
}
